// extracted by mini-css-extract-plugin
export var per_year_events = "index-module--per_year_events--Y7tRQ";